import { ButtonBase, styled } from '@mui/material';

import { getButtonStyles } from './styles';
import { CommonButtonProps } from './types';

type ButtonRootProps = CommonButtonProps & { isViewOnly?: boolean };

export const ButtonRoot = styled(ButtonBase, {
  name: 'ButtonRoot',
  shouldForwardProp: (propName) =>
    !(
      ['fullWidth', 'square', 'whiteSpace', 'isViewOnly'] as PropertyKey[]
    ).includes(propName),
})<ButtonRootProps>(({
  theme,
  variant,
  size,
  fullWidth,
  disabled,
  whiteSpace,
  square,
  isViewOnly,
}) => {
  return getButtonStyles({
    theme,
    variant,
    size,
    fullWidth,
    disabled,
    whiteSpace,
    square,
    isViewOnly,
  });
});
